import { Link } from "react-router-dom";
import { getPlatformUrl, isPlatformHost } from "../../../utils/portalHost";
import L from "../../../constants/baysportLabels";
import { IconMembership, IconVenue } from "../../ui/icons";
import s from "./ownerCabinet.module.css";

function ExternalOwnerLink({ href, children, className }) {
  return (
    <a href={href} className={className}>
      {children}
    </a>
  );
}

function InternalOwnerLink({ to, children, className }) {
  return (
    <Link to={to} className={className}>
      {children}
    </Link>
  );
}

/**
 * Ссылка на кабинет владельца BaySport (клубы + тарифы).
 * На платформе — react-router, на поддомене клуба — полный URL.
 */
export function OwnerCabinetHubLink({
  variant = "card",
  billingActive = false,
}) {
  const onPlatform = isPlatformHost();
  const billingHref = onPlatform ? "/account/billing" : getPlatformUrl("/account/billing");
  const clubsHref = onPlatform ? "/account/clubs" : getPlatformUrl("/account/clubs");

  const LinkWrap = onPlatform ? InternalOwnerLink : ExternalOwnerLink;

  if (variant === "compact") {
    return (
      <LinkWrap
        to={billingHref}
        href={billingHref}
        className={s.ownerHubCompact}
      >
        <span className={s.ownerHubCompactTitle}>Кабинет {L.productName}</span>
        <span className={s.ownerHubCompactText}>Все клубы и тарифы</span>
        <span className={s.ownerHubCompactArrow} aria-hidden>
          →
        </span>
      </LinkWrap>
    );
  }

  return (
    <div className={s.ownerHub}>
      <div className={s.ownerHubText}>
        <span className={s.ownerHubEyebrow}>Кабинет {L.productName}</span>
        <p className={s.ownerHubLead}>Управление клубами, тарифами и оплатой</p>
      </div>
      <div className={s.ownerHubLinks}>
        <LinkWrap
          to={clubsHref}
          href={clubsHref}
          className={`${s.ownerHubLink} ${!billingActive ? s.ownerHubLinkActive : ""}`}
        >
          <IconVenue className={s.ownerHubLinkIcon} aria-hidden />
          <span>Мои клубы</span>
        </LinkWrap>
        <LinkWrap
          to={billingHref}
          href={billingHref}
          className={`${s.ownerHubLink} ${billingActive ? s.ownerHubLinkActive : ""}`}
        >
          <IconMembership className={s.ownerHubLinkIcon} aria-hidden />
          <span>Тарифы</span>
        </LinkWrap>
      </div>
    </div>
  );
}
